module.exports = __webpack_public_path__ + "img/medium_brown.c49a1110.svg";